import React from 'react';

const ToggleSwitch = ({ 
  isOn, 
  onToggle, 
  labelOff = 'Low', 
  labelOn = 'High', 
  colorOff = 'bg-gray-200', 
  colorOn = 'bg-blue-600' 
}) => {
  return (
    <div className="flex items-center space-x-2">
      <span className={`text-xs ${!isOn ? 'font-bold text-blue-600' : 'text-gray-500'}`}>{labelOff}</span>
      <button 
        onClick={onToggle}
        className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors duration-200 ${isOn ? colorOn : colorOff}`}
      >
        <span 
          className={`inline-block h-4 w-4 transform rounded-full bg-white transition duration-200 
          ${isOn ? 'translate-x-6' : 'translate-x-1'}`} 
        />
      </button>
      <span className={`text-xs ${isOn ? 'font-bold text-blue-600' : 'text-gray-500'}`}>{labelOn}</span>
    </div>
  );
};

export default ToggleSwitch; 